import { Group, Text } from '@mantine/core';

type AsideTabProps = {
  icon: React.ReactNode;
  label: React.ReactNode;
  counter?: number;
  value: string;
  activeTab?: string | null;
  onClick?: (tabValue: string) => void;
};

export function AsideTab({
  icon,
  label,
  value,
  activeTab,
  onClick,
}: AsideTabProps) {
  const isActive = value === activeTab;

  return (
    <Group
      noWrap
      h="22px"
      spacing="01"
      w="fit-content"
      px="02"
      py="00"
      sx={theme => ({
        background: isActive ? theme.colors.gray[0] : 'transparent',
        borderRadius: theme.radius.md,
        ':hover': { cursor: 'pointer', background: theme.colors.gray[0] },
      })}
      c="gray.5"
      onClick={() => onClick?.(value)}
    >
      {icon}
      <Group noWrap spacing="02">
        <Text
          variant="sm"
          fw={isActive ? 500 : 400}
          c={isActive ? 'gray.9' : 'gray.7'}
        >
          {label}
        </Text>
      </Group>
    </Group>
  );
}
